/**
 * User-facing product identity.
 * Official name: always exactly "TheRallyAlly" (no spaces, no all-caps, no lowercase domain spelling).
 */
export const APP_NAME = "TheRallyAlly";
/** @deprecated Use APP_NAME — same value */
export const APP_NAME_MARK = APP_NAME;
export const APP_SHORT_NAME = "TheRallyAlly";
export const APP_EMOJI = "🏸";
export const APP_TAGLINE = "Live badminton scoring you'll trust every week";
/** Welcome / sign-in hero line (login screen only). */
export const WELCOME_TAGLINE = "Every Rally. Every Ally.";
export const APP_DESCRIPTION =
  "Live badminton score tracker, match arenas, and player history";
/** Public website label (marketing / share footer) */
export const PUBLIC_SITE_LABEL = "TheRallyAlly.com";
export const SUPPORT_EMAIL = "adeshskumar@gmail.com";
export const SUPPORT_PHONE = "+918657241507";
/** User-facing phone label (tel: href uses SUPPORT_PHONE). */
export const SUPPORT_PHONE_LABEL = "+91 86572 41507";
export const FEEDBACK_URL =
  "https://github.com/adesh-kumar11/shuttlescore/issues/new/choose";

/** Optional external support destinations (non-empty strings are surfaced in UI). */
export const SUPPORT_LINKS = {
  issueTrackerUrl: FEEDBACK_URL,
  featureFormUrl: "",
  helpCenterUrl: "",
};

/** @returns {string | null} Trimmed support inbox, or null when not configured. */
export function getConfiguredSupportEmail() {
  const trimmed = String(SUPPORT_EMAIL ?? "").trim();
  return trimmed || null;
}

/** @returns {string | null} E.164-style phone for tel: links, or null when not configured. */
export function getConfiguredSupportPhone() {
  const trimmed = String(SUPPORT_PHONE ?? "").trim();
  return trimmed || null;
}

export const APP_VERSION =
  typeof process !== "undefined" && process.env?.REACT_APP_VERSION
    ? process.env.REACT_APP_VERSION
    : "1.0.0";

export function installAppLabel() {
  return `Install ${APP_NAME}`;
}

export function shareMatchInviteText() {
  return `Join this badminton match on ${APP_NAME}`;
}
